import { type FormLabelBaseProps, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const CustomFormLabel = styled((props: FormLabelBaseProps) => (
	<Typography
		align="left"
		variant="subtitle1"
		fontWeight={600}
		{...props}
		component="label"
		htmlFor={props.htmlFor}
	/>
))(() => ({
	marginBottom: "5px",
	marginTop: "15px",
	display: "block",
}));

export default CustomFormLabel;
